import { InjectionToken } from '@angular/core';
import { Observable } from 'rxjs';
import { AccountGroup } from './app/account-group';

export const ACCOUNT_GROUP_TOKEN = new InjectionToken<Observable<AccountGroup>>('com.vendasta.bcc.account_group');
export const ACCOUNT_GROUP_ID_TOKEN = new InjectionToken<Observable<string>>('');
